/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleAllocationProportionalServiceCategoryCloudAndPlatform extends models.BillingRuleAllocationGenericTargets {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleAllocationProportionalServiceCategoryCloudAndPlatform");
    }

    getFixupPrototypeFunction() { return BillingRuleAllocationProportionalServiceCategoryCloudAndPlatform.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleAllocationProportionalServiceCategoryCloudAndPlatform>): BillingRuleAllocationProportionalServiceCategoryCloudAndPlatform {
        let obj = Object.assign(new BillingRuleAllocationProportionalServiceCategoryCloudAndPlatform(), model);
        BillingRuleAllocationProportionalServiceCategoryCloudAndPlatform.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleAllocationProportionalServiceCategoryCloudAndPlatform>): BillingRuleAllocationProportionalServiceCategoryCloudAndPlatform {
        if (!model) return null;
        return BillingRuleAllocationProportionalServiceCategoryCloudAndPlatform.newInstance(<BillingRuleAllocationProportionalServiceCategoryCloudAndPlatform> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleAllocationProportionalServiceCategoryCloudAndPlatform) {
        if (!obj) return;

        models.BillingRuleAllocationProportionalServiceCategoryCloudAndPlatform.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleAllocationProportionalServiceCategoryCloudAndPlatform): boolean {
        if (models.BillingRuleAllocationGenericTargets.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleAllocationProportionalServiceCategoryCloudAndPlatform.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * List of service categories to allocate by
     */
    service_categories: Array<string>;

}
